import { gql } from "@apollo/client";

import complianceProgramReportQuestionFragment from "./compliance-program-report-question-fragment";

export default gql`
  ${complianceProgramReportQuestionFragment}

  fragment EngagementSurveyReportResponder on EngagementSurveyReportRespondersNode {
    rollupType
    team {
      id
      title
    }
    manager {
      id
      name
      firstName
      avatar
    }
    careerTrack {
      id
      title
    }
    isManager
    responderCount
    totalResponders
    isHidden
    isCollapsed
    location
  }

  fragment EngagementSurveyReportRowRollup on EngagementSurveyReportRollupNode {
    rollupType
    team {
      id
      title
    }
    manager {
      id
      name
      firstName
      avatar
    }
    careerTrack {
      id
      title
    }
    location
    isManager
    value
  }

  fragment EngagementSurveyReportRow on EngagementSurveyReportRowNode {
    title
    question {
      ...ComplianceProgramReportQuestion
    }
    rollups {
      edges {
        node {
          ...EngagementSurveyReportRowRollup
        }
      }
    }
  }

  query getComplianceProgramEngagementSurveyReport(
    $complianceProgramId: Int!
    $groupBy: EngagementSurveyReportGroupBy!
    $teamIds: [Int]
    $managerIds: [Int]
    $managerIdsFullTree: [Int]
    $employeeStartDateRange: [String]
    $locations: [String]
    $collapsedKeys: [String]
  ) {
    complianceProgram(pk: $complianceProgramId) {
      canReadDetails {
        permission
      }
      hasAccessToAppliesToUsers
      assessmentDeliveries {
        edges {
          node {
            id
          }
        }
      }
      engagementSurveyReport(
        groupBy: $groupBy
        teamIds: $teamIds
        managerIds: $managerIds
        managerIdsFullTree: $managerIdsFullTree
        employeeStartDateRange: $employeeStartDateRange
        locations: $locations
        collapsedKeys: $collapsedKeys
      ) {
        responders {
          edges {
            node {
              ...EngagementSurveyReportResponder
            }
          }
        }
        rangeQuestionRows {
          edges {
            node {
              ...EngagementSurveyReportRow
            }
          }
        }
        npsQuestionRows {
          edges {
            node {
              ...EngagementSurveyReportRow
            }
          }
        }
      }
    }
  }
`;
